export default __webpack_public_path__ + "static/media/field.f8a323c9.png";